import envVar from "../config/envVars";
import httpGet from "./httpClient/httpGet";

const getRetoolEmbedUrl = async (pageName: string) =>
  httpGet(
    `${envVar.REACT_APP_BASE_API_URL}/admin/retool-embed-url?retoolPage=${pageName}`
  );

const adminApis = { getRetoolEmbedUrl };
export default adminApis;
